<template>
    <modal size="lg" @close="reset(); $emit('close')" ref="modal" :autoshow="true">
        <template v-slot:title>
            <div class="d-flex justify-content-between">
                <h3 class="modal-title">Earnings Statement</h3>
            </div>
        </template>

        <slot>
            <earnings-statement-view
                v-if="dataLoaded"
                :client="client"
                :employee="employee"
                :statement="statement"
                :result="earningsStatementResult"
                :paychecks="paychecks"
                :earning-types="earningTypes"
                :company-earning-types="clientEarningTypes"
                :ytd="ytd"
                :tax-configs="employee.sym_tax_config"
                :blocked-deductions="statement.blocked_deductions"
                :blocked-taxes="statement.blocked_taxes"
                :show-payout="true"
                :show-ytd="true"
            />
        </slot>

        <template v-slot:footer>
            <form-errors :errors="formErrors"/>

            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">
                    Done
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'
import EarningsStatementView from './EarningsStatementView'

export default {
    props: ['client', 'employeeId', 'earningsStatementId', 'earningTypes', 'clientEarningTypes'], // TODO KB PG provide defaults
    mixins: [FormMixin, ModalMixin],
    components: {EarningsStatementView},
    emits: ['updated', 'close', ],
    data() {
        return {
            dataLoaded: false,
            employee: null,
            paychecks: [],
            statement: null,
            earningsStatementResult: null,
            ytd: null,
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getEmployee() {
            return this.$api.get(`/clients/${this.client.id}/payroll/employees/${this.employeeId}`).then(resp => {
                this.employee = resp
            })
        },
        getEarningsStatement() {
            return this.$api.get(`/clients/${this.client.id}/payroll/paygrid/earnings-statements/${this.earningsStatementId}/net-pay`).then(resp => {
                this.paychecks = resp['paychecks']
                this.statement = resp['earnings_statement']
                this.earningsStatementResult = resp['earnings_statement_result'] // result from the net pay engine
                this.ytd = resp['ytd']
            })
        },
        getData() {
            this.$store.dispatch('START_LOADING')
            Promise.all([this.getEmployee(), this.getEarningsStatement()]).then(() => {
                this.dataLoaded = true
                this.$store.dispatch('STOP_LOADING')
            }).catch(err => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError('Could not load earnings statement data. Please refresh the page and try again.')
            })
        },
    }
}
</script>
